import useTranslation from 'customHooks/translate';

const TermsConditionsRu = () => {
  return (
    <div>
      <p>
        Подписывая настоящие Правила, Вы заявляете и подтверждаете, что
        полностью и безусловно соглашаетесь с условиями, установленными в
        настоящих Правилах, и принимаете эти условия.
      </p>
      <p className="mt-[10px]">
        <span className="mt-[10px] text-[20px] font-semibold">
          1. ОСНОВНЫЕ ПОНЯТИЯ
        </span>{' '}
        <br /> Основные понятия, используемые в настоящих Правилах, и их
        значения следующие: <br />{' '}
        <span className="font-semibold">Компания</span> – Общество с
        ограниченной ответственностью «DIGERA» (ИНН: 2007374731), являющееся
        владельцем «invoice-reporter.com» и организующее и обеспечивающее его
        управление. <br />{' '}
        <span className="font-semibold"> «invoice-reporter.com»</span> –
        программное обеспечение, включающее ввод данных о доходах и расходах,
        операторах, менеджерах, операторах и проектах, осуществление подготовки
        отчетов в онлайн-режиме, подготовку инвойсов (счетов-фактур) и их
        отправку клиентам, регулирование всех этапов банковских операций от
        начала до завершения, информацию, связанную с клиентами, заметки и
        задания о них, а также деятельность пользователя. <br />{' '}
        <span className="font-semibold">Пользователь</span> – любое лицо
        (юридическое или физическое), использующее «invoice- reporter.com».
        <br /> <span className="font-semibold"> Персональные данные</span> –
        любая информация личного характера, позволяющая прямо или косвенно
        идентифицировать пользователя. <br />{' '}
        <span className="font-semibold">Интернет-страница</span> –
        www.invoice-reporter.com Мобильное приложение (дополнение): мобильное
        приложение, загруженное из App Store и Play Market под названием
        «invoice-reporter.com». <br />
        <span className="font-semibold">Регистрация</span> – процесс,
        позволяющий использовать «invoice-reporter.com» путем ввода персональных
        данных и согласия с настоящими Правилами. <br />
        <span className="font-semibold">Аккаунт</span> – страница, отражающая
        информацию о Пользователе и позволяющая использовать
        «invoice-reporter.com». <br />
        <span className="font-semibold">Тариф</span> – денежная сумма,
        определяемая исключительно Компанией за использование
        «invoice-reporter.com».
      </p>
      <p className="mt-[10px]">
        Настоящие Правила определяют порядок и условия использования
        «invoice-reporter.com» и регулируют правовые отношения между Компанией и
        Пользователем.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          2. РЕГИСТРАЦИЯ В «invoice-reporter.com»
        </span>{' '}
        <br />
        Для использования «invoice-reporter.com» Пользователь в первую очередь
        должен пройти регистрацию через интернет-страницу. После ввода
        соответствующих данных и выполнения необходимых шагов для Пользователя
        будет создан индивидуальный аккаунт, и Пользователь может самостоятельно
        добавлять данные в аккаунт и управлять аккаунтом. Аккаунт создается
        только в том случае, если все данные введены корректно и в соответствии
        с соответствующей инструкцией пользователя. Пользователь несет
        ответственность за достоверность данных, введенных при регистрации, а
        также за регулярное обновление изменений в данных, относящихся к
        Пользователю после регистрации. В случае установления того, что данные,
        введенные Пользователем при регистрации, являются неверными, фиктивными
        или ложными, и при наличии обоснованных подозрений в этом, Компания
        имеет право ограничить, заблокировать, удалить аккаунт Пользователя и
        запретить использование «invoice-reporter.com». Также при необходимости
        Компания может передать необходимую информацию для расследования факта
        ложной регистрации в Правоохранительные органы. В соответствии с
        требованиями законодательства Азербайджанской Республики «invoice-
        reporter.com» собирает и обрабатывает только персональные данные,
        введенные Пользователем. Вводя персональные данные, Пользователь
        считается давшим согласие на их сбор и обработку «invoice-reporter.com».
        При использовании «invoice-reporter.com» Пользователь несет
        ответственность за последствия своих действий или бездействия (вход в
        аккаунты третьих лиц на любых условиях или предоставление третьим лицам
        доступа к своему аккаунту и т.п.), а также за несоблюдение
        конфиденциальности данных.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          3. ЛОГИН (E-MAIL) И ПАРОЛЬ
        </span>{' '}
        <br />
        После успешного завершения регистрации в «invoice-reporter.com» для
        Пользователя создается индивидуальный аккаунт. При регистрации
        Пользователь должен выбрать логин (e-mail) и пароль, определяемые им
        самостоятельно для входа в аккаунт. Компания может запретить
        использование определенных логинов, а также установить определенные
        обязательные требования к паролю (количество используемых символов, их
        состав и т.п.). Выбранные Пользователем логин (e-mail) и пароль являются
        важной и конфиденциальной информацией. Обеспечение их конфиденциальности
        является обязанностью Пользователя и направлено на защиту его интересов.
        Для обеспечения безопасности аккаунта по завершении каждой сессии,
        выполняемой с «invoice-reporter.com», требуется самостоятельно выходить
        из аккаунта (с помощью кнопки «выход»). В противном случае Компания не
        несет ответственности за потерю данных в «invoice- reporter.com» и любые
        другие возможные негативные последствия. Если Пользователь обнаружит или
        заподозрит, что доступ к аккаунту ограничен, а также что
        конфиденциальность пароля нарушена, он должен немедленно уведомить об
        этом Компанию. Своевременная реакция Пользователя в таких случаях
        помогает Компании эффективно реализовать меры безопасности.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          4. ОГРАНИЧЕНИЕ И УДАЛЕНИЕ АККАУНТА
        </span>{' '}
        <br />В случае нарушения Пользователем условий настоящих Правил
        Компания, используя свои исключительные полномочия, имеет право без
        указания причин ограничить, заблокировать, удалить аккаунт Пользователя
        вместе со всем содержимым и запретить его использование. С этого момента
        использование аккаунта Пользователя и данных, содержащихся в аккаунте,
        восстановление использования аккаунта, восстановление аккаунта, а также
        восстановление данных, содержащихся в аккаунте, невозможно.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">5. ПОРЯДОК ОПЛАТЫ</span>{' '}
        <br />
        Использование «invoice-reporter.com» является платным. Компания может
        предоставить первые 90 (девяносто) дней использования «invoice-
        reporter.com» бесплатно в качестве пробного периода. После окончания
        пробного периода для использования «invoice-reporter.com» оплата должна
        быть произведена в соответствии с тарифной таблицей и условиями оплаты,
        размещенными на сайте Компании. Изменение размера платы за использование
        «invoice-reporter.com», указанной в тарифной таблице, а также внесение в
        нее дополнений является исключительным правом Компании. Выбирая
        подходящий тариф, Пользователь принимает на себя обязательство
        оплачивать использование «invoice-reporter.com». Пользователь обязан
        осуществлять оплату за использование «invoice-reporter.com» своевременно
        и в полном объеме. В случае несвоевременной или неполной оплаты право
        Пользователя на использование «invoice-reporter.com» будет ограничено.
        Оплата может быть произведена через наш сайт, с использованием
        банковских карт (VISA / MasterCard и другие), а также путем перечисления
        денежных средств на расчетный счет Компании.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          6. ОХРАНА ИНТЕЛЛЕКТУАЛЬНОЙ СОБСТВЕННОСТИ И ИНЫХ ПРАВ
        </span>{' '}
        <br />
        Права на программное обеспечение «invoice-reporter.com» принадлежат
        Компании. Компания сохраняет за собой все права, прямо выраженные или не
        выраженные в настоящих Правилах. Соглашаясь с настоящими Правилами,
        Пользователь не приобретает «invoice- reporter.com», а лишь получает
        право его использования.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          7. ОГРАНИЧЕНИЕ ПРАВ ПОЛЬЗОВАТЕЛЯ
        </span>{' '}
        <br />
        Пользователь не вправе копировать программное обеспечение,
        воспроизводить его, разбирать на составные части, декомпилировать или
        пытаться выявить исходный код или алгоритмы программного обеспечения,
        изменять любые его функции, осуществлять кибератаки с целью приведения
        его в неработоспособное состояние, а также использовать программное
        обеспечение в иных целях. Пользователь не вправе передавать программное
        обеспечение в пользование третьим лицам. В случае выявления Компанией
        любого незаконного использования Пользователем она вправе без
        направления какого-либо дополнительного уведомления ограничить
        использование «invoice-reporter.com» Пользователем и аннулировать
        аккаунт без возврата какой-либо суммы.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          8. ОБЯЗАННОСТИ ПОЛЬЗОВАТЕЛЯ
        </span>{' '}
        <br />
        Пользователь несет личную ответственность за использование аккаунта.
        Компания не осуществляет проверки и контроль информации, размещаемой в
        аккаунте или передаваемой через систему «invoice-reporter.com».
        Пользователь самостоятельно несет ответственность за передачу информации
        и за использование «invoice-reporter.com» в соответствии с
        законодательством. Принимая использование «invoice-reporter.com»,
        Пользователь безусловно соглашается соблюдать законодательство
        Азербайджанской Республики при использовании «invoice- reporter.com».
        Пользователь несет личную ответственность за любые противоправные
        действия, совершенные при использовании «invoice-reporter.com».
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          9. СОГЛАСИЕ НА ИСПОЛЬЗОВАНИЕ ДАННЫХ
        </span>{' '}
        <br />
        Пользователь принимает и подтверждает, что при использовании
        «invoice-reporter.com» он передает свои персональные данные на сервер.
        Компания обеспечивает передачу и обработку персональных данных с
        соблюдением требований законодательства о защите персональных данных.
        Пользователь также принимает и подтверждает, что не возражает против
        хранения его данных на международных серверах, расположенных за
        пределами территории Азербайджанской Республики. При использовании
        «invoice-reporter.com» Пользователь безусловно дает согласие на
        обработку принадлежащих ему персональных данных (запись, систематизация,
        обновление, изменение, извлечение, хранение, передача, уничтожение и
        т.д.). Данные Пользователя могут размещаться в «облачных» хранилищах,
        расположенных в иностранных государствах. Пользователь безусловно
        соглашается на трансграничную передачу персональных данных, а также на
        их размещение, хранение и обработку в облаках, расположенных в
        иностранных государствах.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">10. ГАРАНТИИ</span> <br />
        Компания несет ответственность за защиту и хранение всех данных,
        введенных Пользователем в связи с использованием «invoice-reporter.com».
        Ответственность Компании перед Пользователем за ущерб, причиненный
        Пользователю в результате использования «invoice-reporter.com», не может
        превышать сумму, уплаченную Пользователем Компании.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          11. ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ
        </span>{' '}
        <br />
        Компания не несет никакой ответственности за любой ущерб, возникший в
        результате использования или невозможности использования
        «invoice-reporter.com», а также за ошибки, которые могут возникнуть при
        использовании программы, или за связанные с этим убытки, недостатки,
        внешние вмешательства, дефекты, задержки в операциях или передаче
        данных, компьютерные вирусы, невозможность подключения. Компания не
        несет ответственности за операции, совершенные на основании ложных или
        фиктивных данных. Компания не несет ответственности за правильность
        документов (отчетов, инвойсов, банковских документов и т.п.),
        подготовленных в «invoice-reporter.com». Компания не несет
        ответственности за ущерб, возникший в результате любых ошибочных данных,
        введенных Вами при подготовке документов.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          12. ОБНОВЛЕНИЯ И НАСТРОЙКИ
        </span>{' '}
        <br />
        Компания вправе на регулярной основе выполнять обновления, настройки,
        усовершенствования и иные необходимые работы в «invoice-reporter.com» с
        целью обеспечения его постоянной работоспособности и качественной
        работы. В обновленную версию «invoice-reporter.com» могут добавляться
        новые функции, а в некоторых случаях существующие функции могут быть
        удалены.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          13. ПЕРЕДАЧА ТРЕТЬИМ ЛИЦАМ
        </span>{' '}
        <br />
        Пользователь не вправе ни при каких условиях и ни в какой форме
        передавать третьим лицам права, предоставленные ему на использование
        «invoice-reporter.com» или иного связанного программного обеспечения.
      </p>
      <p className="mt-[10px]">
        <span className="text-[20px] font-semibold">
          14. ПРИМЕНИМОЕ ПРАВО И ПОРЯДОК РАЗРЕШЕНИЯ СПОРОВ
        </span>
        <br />
        Настоящие Правила регулируются законодательством Азербайджанской
        Республики и подлежат толкованию в соответствии с ним. Все споры,
        возникающие из настоящих Правил, связанные с «invoice-reporter.com» или
        в связи с ним, если они не могут быть разрешены путем переговоров между
        сторонами, подлежат разрешению соответствующими судами Азербайджанской
        Республики в соответствии с законодательством Азербайджанской
        Республики.
      </p>
    </div>
  );
};

export default TermsConditionsRu;
